<template>
  <span :id="dropdownID" class="dropdown">
    <button :class="`btn btn-${variant} dropdown-toggle`" :id="`dropdownMenuButton${id}`" type="button" aria-haspopup="true" aria-expanded="false">
      <fa icon="bars" />
    </button>
    <div :aria-labelledby="`dropdownMenuButton${id}`" class="dropdown-menu dropdown-menu-right">
      <span class="dropdown-item">
        <div class="input-group">
          <label for="author" class="col-md-3 col-form-label text-md-right">{{ $t('author') }}</label>
          <div class="col-md-9"><input id="author" :placeholder="$t('author')" v-model="search.author" type="text" name="author" class="form-control"></div>
        </div>
      </span>
      <span class="dropdown-item">
        <div class="input-group">
          <label for="title" class="col-md-3 col-form-label text-md-right">{{ $t('title') }}</label>
          <div class="col-md-9"><input id="title" :placeholder="$t('title')" v-model="search.title" type="text" name="title" class="form-control"></div>
        </div>
      </span>
      <span class="dropdown-item">
        <div class="input-group">
          <label for="title" class="col-md-3 col-form-label text-md-right">{{ $t('contact_occupation') }}</label>
          <div class="col-md-9">
            <button :id="`${id}IscoButton`" class="btn btn-primary btn-isco" @click.prevent="showISCO(id+'Modal')">{{ $t(search.isco ? search.isco : 'isco_selector.choose_an_occupation') }}</button>
            <button v-if="search.isco" :id="`${id}IscoReset`" class="btn btn-danger btn-isco-reset" @click.prevent="resetISCO()">
              <fa icon="times" />
            </button>
          </div>
        </div>
      </span>
      <span class="dropdown-item">
        <div class="input-group">
          <label for="title" class="col-md-3 col-form-label text-md-right">{{ $t(checkboxText) }}</label>
          <div class="col-md-9">
            <Checkbox :name="`cbxValid${id}`" v-model="search.valid" @click.native.stop=""/>
          </div>
        </div>
      </span>
      <slot />
    </div>
    <ISCOSelectorModal ref="iscoModal" :id="`${id}Modal`" @saved="iscoSaved" @closed="iscoClosed(id+'Modal')" />
  </span>
</template>

<style scoped>
.dropdown-menu {
  min-width: 400px;
}
.btn-isco, .btn-isco-reset {
  margin-top: 0;
}
</style>

<script>
export default {
  name: 'DropDownSearchProfiles',

  props: {
    id: { type: String, default: null },
    variant: { type: String, default: 'secondary' },
    checkboxText: { type: String, default: 'approved' }
  },

  data: () => ({
    search: {},
    iscoValid: false
  }),
  computed: {
    dropdownID () {
      return 'dropdown' + this.id
    }
  },

  watch: {
    search: {
      handler: function (oldV, newV) {
        this.$emit('input', newV)
      },
      deep: true
    }
  },
  mounted: function () {
    var self = this
    $('#dropdownMenuButton' + this.id).click(function (e) {
      e.preventDefault()
      $('#' + self.dropdownID).toggleClass('show')
      $('#' + self.dropdownID + ' > .dropdown-menu').toggleClass('show')
    })
    $('body').on('click', function (e) {
      if (!$('#' + self.dropdownID).is(e.target) &&
          $('#' + self.dropdownID).has(e.target).length === 0 &&
          $('.open').has(e.target).length === 0
      ) {
        $('#' + self.dropdownID).removeClass('show')
        $('#' + self.dropdownID + ' > .dropdown-menu').removeClass('show')
      }
    })
  },

  methods: {
    iscoSaved (occupation) {
      this.$set(this.search, 'isco', occupation)
    },
    iscoClosed (id) {
      $('#' + id).modal('show')
    },
    showISCO (id) {
      $('#' + id).modal('show')
    },
    resetISCO () {
      this.$set(this.search, 'isco', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/DropDownSearchProfiles.vue